import { isPlainObject, keys, isArray } from 'lodash-es'

const transformer = function (origin, defs) {
  // 对象{}
  if (isPlainObject(origin)) {
    const keyArr = keys(origin)

    if (keyArr.includes('text')) {
      return {
        render: 'text',
        origin,
        value: origin.text,
        onClick: origin.onClick,
        defs,
      }
    }
    if (keyArr.includes('value')) {
      return {
        render: 'text',
        origin,
        value: origin.value,
        onClick: origin.onClick,
        defs,
      }
    }
  }
  if (isArray(origin) || isPlainObject(origin)) {
    let data
    try {
      data = JSON.stringify(origin)
    } catch (e) {
      data = 'error'
    }
    return {
      render: 'text',
      origin,
      value: data,
      onClick: origin.onClick,
      defs,
    }
  }

  return {
    render: 'text',
    origin,
    value: origin,
    onClick: origin.onClick,
    defs,
  }
}

export default transformer
